import {ReactNode, useEffect} from 'react';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {Loading} from '../../../../../../design-system/atoms/Loading/Loading';
import {useViewerInfoQuery} from '../../../../../../wrapper/viewerWrapper';
import {events} from '../constant/textViewerSagaEvents';
import {useAllFontsLoaded} from '../hook/useAllFontsLoaded.hook';
import {clearTextViewerError} from '../state/textViewerSlice';
import {TextViewerFontFamilyType} from '../type/TextViewerFontFamilyType.enum';

export function PreviewTextViewerFetcherHeadless({
  seriesId,
  productId,
  children,
}: {
  seriesId: number;
  productId: number;
  children: ReactNode;
}) {
  const {isDataLoaded, error} = useTypedSelector(state => ({
    isDataLoaded: state.textViewer.viewData[productId]?.isDataLoaded || false,
    error: state.textViewer.viewData[productId]?.error,
  }));
  const dispatch = useTypedDispatch();
  const isLoaded = useAllFontsLoaded({
    fontList: Object.values(TextViewerFontFamilyType),
  });
  const {data} = useViewerInfoQuery({seriesId, productId});
  const viewerInfo = data;

  useEffect(() => {
    if (viewerInfo) {
      dispatch(
        events.textViewerEntered({
          seriesId,
          productId,
          isPreview: true,
          viewerInfoData: viewerInfo,
        })
      );
    }
  }, [dispatch, productId, seriesId, viewerInfo]);

  useEffect(() => {
    if (error) {
      throw error;
    }
    return () => {
      dispatch(clearTextViewerError({productId}));
    };
  }, [dispatch, error, productId]);

  return isDataLoaded && isLoaded ? (
    <>{children}</>
  ) : (
    <div className="flex-center-full">
      <Loading />
    </div>
  );
}
